import { reactive, ref } from 'vue'
import store from '@/store'
import { Notify } from 'vant'
import router from '@/router'
import base from '@/utils/base64'

export const loading = ref(false)
export const state = reactive({
  phoneNumber: '',
  verificationCode: '',
  password: ''
})
// 提交表单（登录）
export const onSubmit = (values) => {
  loading.value = true // 登录中
  store
    .dispatch('login', values)
    .then(({ status, message, data }) => {
      if (status === 200) {
        // 登录成功
        console.log(data)
        Notify({ type: 'success', message: '登录成功' })
        localStorage.setItem('username', base.encode(values.username))
        localStorage.setItem('password', base.encode(values.password))
        if (
          values.username === 'admin' ||
          values.username === '15041232200' ||
          values.username === '18698807761' ||
          data.userInfo.tenantId
        ) {
          localStorage.setItem('tenant_longitude', data.userInfo.longitude)
          localStorage.setItem('tenant_latitude', data.userInfo.latitude)
          if (data.userInfo.regionCode) {
            localStorage.setItem('tenant_region', data.userInfo.regionCode)
          }
          console.log(data.userInfo.regionCode)
          localStorage.setItem('tenant_id', data.userInfo.tenantId)
          console.log(data.userInfo.tenantId)
          router.replace('/managementHome')
        } else {
          localStorage.setItem('tenant_longitude', '')
          localStorage.setItem('tenant_latitude', '')
          localStorage.setItem('tenant_region', '')
          localStorage.setItem('tenant_id', '')
          router.replace('/welcome')
        }
      } else {
        // 登录失败警告
        Notify({ type: 'warning', message })
      }
      loading.value = false
    })
    .catch(() => {
      // 登录错误提示
      Notify({ type: 'danger', message: '登录异常' })
      loading.value = false
    })
}

export default {
  loading,
  onSubmit
}
